var _jsxFileName = "/codebuild/output/src1174814487/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/Input/index.tsx";
import React, { memo } from 'react';
import { IconValidationInvalid, TextInput } from '@adc/parallax-component-library';
const Input = /*#__PURE__*/memo(({
  isInvalid = false,
  label = '',
  errorMessage,
  placeholder = '',
  value,
  onBlur,
  onChangeText,
  disabled,
  testID,
  inputMode,
  onFocus,
  maxLength
}) => {
  const showsErrorMessage = isInvalid && errorMessage;
  return /*#__PURE__*/React.createElement(TextInput, {
    inputMode: inputMode,
    "aria-label": label,
    label: label,
    placeholder: placeholder,
    onFocus: onFocus,
    onBlur: onBlur,
    error: isInvalid,
    supportingText: showsErrorMessage ? errorMessage : undefined,
    supportingIconConfig: showsErrorMessage ? {
      icon: /*#__PURE__*/React.createElement(IconValidationInvalid, {
        testID: `${testID}-icon`,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 23
        }
      }),
      color: '$support.danger.surfaceOnColorAlt'
    } : undefined,
    onChangeText: onChangeText,
    value: value,
    testID: testID,
    disabled: disabled,
    maxLength: maxLength,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  });
});
Input.displayName = 'Input';
export { Input };